import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import * as Styled from './styles';
import { specificDates } from './utils';

const ToPayList = ({ data }: { data: number[][] }): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);

  return (
    <FlexContainer direction="column" align="center" gap="dimension_08">
      <Text type="paragraphs" color="grey" size="XS_S_S">
        {t('ToPay.list.title')}
      </Text>
      <Styled.ListContainer justifyContent="center" $items={data.length} justifyItems="flex-start">
        {data.map((item, index) => (
          <Text key={item[0]} type="paragraphs" color="grey" size="XS_S_S">
            {t('ToPay.list.item', {
              amount: YayoyakiFormatter.formatAmountMxn(Number(item)),
              index: index + 1,
              date: specificDates[index],
            })}
          </Text>
        ))}
      </Styled.ListContainer>
    </FlexContainer>
  );
};

export default ToPayList;
